<!--
 - Author : wanghongling.
 - Date   : 2018/10/16.
 - File   : bar.柱状图组件
 -->

<template>
  <div :id="id" :style="{width: '100%', height: barList.height, margin: barList.margin}">
  </div>
</template>

<script>
  export default {
    name: 'my-bar',
    data() {
      return {
        myBar: null
      }
    },
    props: {
      id: {
        type: String,
        default: 'test'
      },
      barList: {}
    },
    watch: {
      barList: {
        handler() {
          this.$nextTick(() => {
            // window.removeEventListener('resize', this.resizeEvent)
            this.makeBar()
          })
        },
        deep: true
      }
    },
    destroyed() {
      this.$echarts.dispose(this.myBar)
      // window.removeEventListener('resize', this.resizeEvent)
      this.myBar = null
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.myBar = this.$echarts.init(document.getElementById(this.id))
        this.makeBar()
      },
      makeBar() {
        let series = []
        let item = {}
        let nameList = []
        let list = this.barList.list.data
        let noSplit = this.barList.noSplit
        for (let i = 0; i < list.length; i++) {
          item = {
            type: 'bar',
            label: {
              show: this.barList.labelShow || false,
              position: 'top',
              padding: 0,
              color: '#ffffff',
              fontSize: 16
            },
            stack: this.barList.stack,
            barWidth: this.barList.barWidth | 'auto',
            name: this.barList.list.name[i],
            color: this.barList.list.color[i],
            itemStyle: this.barList.itemStyle,
            data: this.barList.list.data[i]
          }
          series.push(item)
          nameList.push(this.barList.list.name[i])
        }
        let formatter = this.barList.year ? (this.barList.year + '-' + '{b}<br />' + '{a}：{c}' + this.barList.yName) : ''
        let that = this
        let option = {
          tooltip: {
            trigger: 'axis',
            textStyle: {
              align: 'left',
              fontSize: 14
            },
            backgroundColor: 'rgba(0, 0, 0, 0.55)',
            borderColor: '#155a8d',
            borderWidth: 1,
            formatter: formatter
          },
          legend: {
            show: this.barList.show || false,
            x: this.barList.x,
            y: this.barList.y,
            itemWidth: 10,
            itemHeight: 8,
            padding: [
              0, // 上
              0, // 右
              0, // 下
              0 // 左
            ],
            data: nameList,
            textStyle: {
              fontSize: 16,
              color: '#068ddb'
            }
          },
          barCategoryGap: '22.5%',
          grid: {
            left: this.barList.gridLeft || '0',
            right: this.barList.gridRight || '3%',
            bottom: this.barList.gridBottom || '2%',
            top: this.barList.gridTop || '20%',
            containLabel: true,
            y2: 500
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: true, // 坐标轴两边留白
              data: this.barList.xData,
              name: this.barList.xName || '',
              nameLocation: 'end',
              nameTextStyle: {
                color: this.barList.XNameColor || '#1ce2ff',
                fontSize: 14
              },
              axisPointer: {
                type: 'shadow'
              },
              axisLabel: {
                formatter: function(value) {
                  var ret = '' // 拼接加\n返回的类目项
                  var maxLength = that.barList.formatterWidth || 6 // 每项显示文字个数
                  var valLength = value.length // X轴类目项的文字个数
                  var rowN = Math.ceil(valLength / maxLength) // 类目项需要换行的行数
                  if (!noSplit && rowN > 1) {
                    // 如果类目项的文字大于3,
                    for (var i = 0; i < rowN; i++) {
                      var temp = '' // 每次截取的字符串
                      var start = i * maxLength // 开始截取的位置
                      var end = start + maxLength // 结束截取的位置
                      // 这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                      temp = value.substring(start, end) + '\n'
                      ret += temp // 凭借最终的字符串
                    }
                    return ret
                  } else {
                    return value
                  }
                },
                textStyle: {
                  interval: 0,
                  color: this.barList.XColor || '#03a3ff',
                  fontSize: this.barList.XFontSize || 14 // 让字体变大
                },
                interval: 0
              },
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  color: '#2067d4'
                }
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: ('单位：' + this.barList.yName) || '',
              nameGap: this.barList.nameGap || 14,
              nameTextStyle: {
                color: this.barList.YNameColor || '#1ce2ff',
                fontSize: 15,
                padding: this.barList.padding || [0, 4, 5, 30]
              },
              max: this.barList.yMax,
              interval: this.barList.interval,
              splitLine: {
                show: true,
                lineStyle: {
                  color: '#192e4f'
                }
              },
              axisLabel: {
                textStyle: {
                  color: this.barList.YColor || '#0881c7',
                  fontSize: this.barList.YFontSize || 13 // 让字体变大
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  color: '#0061cf'
                }
              }
            }
          ],
          animationDuration: 3000,
          animationDurationUpdate: 3000,
          series: series,
          animationEasing: 'elasticOut',
          animationDelay: function (idx) {
            return idx * 280 + 100
          }
        }
        this.myBar.setOption(option)
        // window.addEventListener('resize', this.resizeEvent)
      },
      /**
       * echart图表适应
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      resizeEvent () {
        this.myBar.resize() // 使图表适应
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/echarts/bar.vue